import Customer from "./admin/Customer";
import BroadcastSMS from "./admin/BroadcastSMS";
import Route from "./admin/Route";
import Person from "./admin/Person";
import Resident from "./admin/Resident";
import Employee from "./admin/Employee";
import PeerReview from "./admin/PeerReview";
import FileManager from "./admin/FileManager";

export const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  borderRadius: "4px",
  boxShadow: 24,
  p: 4,
};

export const PAGES = Object.freeze([
  {
    link: "customer",
    label: "Customer",
    component: Customer,
  },
  {
    link: "broadcast",
    label: "Broadcast",
    component: BroadcastSMS,
  },
  {
    link: "delivery-route",
    label: "Route",
    component: Route,
  },
  {
    link: "delivery-person",
    label: "Delivery",
    component: Person,
  },
  {
    link: "residents",
    label: "Residents",
    component: Resident,
  },
  {
    link: "employees",
    label: "Employees",
    component: Employee,
  },
  {
    link: "file-manager",
    label: "File Manager",
    component: FileManager,
  },
  {
    link: "peer_reviews",
    label: "Peer Reviews",
    component: PeerReview,
  },
]);

export const ADMIN_PAGES = PAGES.filter(
  (page) => !["peer_reviews"].includes(page.link)
);

export const MANAGER_PAGES = PAGES.filter((page) =>
  ["residents", "staff_points"].includes(page.link)
);

export const STAFF_PAGES = PAGES.filter((page) =>
  ["peer_reviews"].includes(page.link)
);
